export default __webpack_public_path__ + "static/media/35.ec7a813f.jpg";